import React from 'react';
import { Link } from 'react-router-dom';
import MediaQuery from 'react-responsive';

import './ProjectsShowcase.css';
import ProjectInfoBox from './ProjectInfo';
import UnderlinedButton from '../../underlinedButton/UnderlinedButton';
import { eventTypes, trackEvent } from '../../helpers/AnalyticsManager';


import videoPublic from '../../images/home/apresentacoes_voxar.mp4';
import vidEmotion from '../../images/home/EmotionRamDemo.mp4';
import vidDark from '../../images/home/darkDemo.mp4';
import vidSiu from '../../images/home/siuDemo.mp4';
import imgAquiles from '../../images/home/aquilesDemo.jpg';

function ProjectsShowcaseSection() {
  return (
    <header id="projects-showcase">
      <div className="top-portion">
        <h4>
          Portfólio de
          <br />
          tecnologias
        </h4>
        <div className="separator" />
      </div>

      <div className="middle-portion">
        <div className="grid">
          <div className="top">
            <Link to="project/Si.u" className="showcase-project-cell" id="project1">
              <div className="showcase-cell-overlay">
                <h6>Si.u</h6>
                <p>TECNOLOGIA</p>
                <p>
                  Detecção e rastreio
                  <br />
                  de pedestres e atividades
                </p>
              </div>
              <video id="videoSiu" src={vidSiu} autoPlay muted loop />
              <ProjectInfoBox title="Si.u" tag="TECNOLOGIA" />
            </Link>
            <Link to="project/EmotionRam" className="showcase-project-cell" id="project2">
              <div className="showcase-cell-overlay">
                <h6>EmotionRam</h6>
                <p>TECNOLOGIA</p>
                <p>
                Detecção e reconhecimento
                  <br />
                  de emoções humanas
                </p>
              </div>
              <video id="videoEmotion" src={vidEmotion} autoPlay muted loop />
              <ProjectInfoBox title="EmotionRam" tag="TECNOLOGIA" />
            </Link>
          </div>
          <div className="bottom">
            <Link to="project/D.A.R.K" className="showcase-project-cell" id="project3">
              <div className="showcase-cell-overlay">
                <h6>D.A.R.K</h6>
                <p>TECNOLOGIA</p>
                <p>
                  Detecção e rastreio
                  <br />
                  de objetos e artefatos
                </p>
              </div>
              <video id="videoDark" src={vidDark} autoPlay muted loop />
              <ProjectInfoBox title="D.A.R.K" tag="TECNOLOGIA" />
            </Link>
            <Link to="project/A.qu.i.l.es" className="showcase-project-cell" id="project4">
              <div className="showcase-cell-overlay">
                <h6>A.qu.i.l.es</h6>
                <p>TECNOLOGIA</p>
                <p>
                Detecção automatizada
                  <br />
                  de anomalias e defeitos
                </p>
              </div>
              <img src={imgAquiles} alt="Anomalies detection" />
              <ProjectInfoBox title="A.qu.i.l.es" tag="TECNOLOGIA" />
            </Link>
          </div>
          <div className="more-button">
            <UnderlinedButton
              redirect="/portfolio"
              title="VER MAIS"
              beforeAction={() => trackEvent(eventTypes.homeProjects)}
            />
          </div>
        </div>
      </div>

      <div className="secPublic">
        <div className="vidPublic">
          <video src={videoPublic} autoPlay muted loop />
        </div>
        <div className="bottom-portion">
          <h6>CONTRIBUIÇÕES INOVADORAS EM:</h6>
          <p>
            <span>#</span>
            RASTREIO
            {' '}
            <MediaQuery query="(max-width: 425px)">
              <br />
            </MediaQuery>
            <span>#</span>
            APRENDIZADO DE MÁQUINA
            <br />
            <span>#</span>
            ROBÓTICA
            {' '}
            <MediaQuery query="(max-width: 425px)">
              <br />
            </MediaQuery>
            <span>#</span>
            DESENVOLVIMENTO DE APPS
            <br />
            <span>#</span>
            VISÃO COMPUTACIONAL
            <br />
            <span>#</span>
            INTELIGÊNCIA ARTIFICIAL
          </p>
          <UnderlinedButton
            redirect="/publications"
            title="PUBLICAÇÕES"
            beforeAction={() => trackEvent(eventTypes.homePublications)}
          />
        </div>
      </div>
    </header>
  );
}

export default ProjectsShowcaseSection;
